<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        Add licence
      </h3>

      <validation-observer ref="licence-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="licence_number"
              v-slot="{ errors }">
              <label for="licence_number">Licence number:</label>
              <d-input
                v-model="data.licence_number"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'LicencePopup',
  data () {
    return {
      isVisible: false,
      loading: false,
      data: {
        name: '',
        licence_number: '',
        crew_id: null,
      }
    };
  },
  mounted () {
    this.$bus.$on('show-licence-popup', this.show);
  },
  methods: {
    show (crewId = false) {
      this.data = {
        licence_number: '',
        crew_id: crewId
      };

      setTimeout(() => {
        this.$refs['licence-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    validateForm () {
      FormUtils.validate(this.$refs['licence-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/crews/licences/store',
        formData: formDataToSend,
        successTitle: 'Licence added',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the licence. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('licences-list-reload');
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let dataToSend = {
        licence_number: this.data.licence_number,
        crew_id: this.data.crew_id
      };

      return dataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-licence-popup', this.show);
  }
}
</script>
